<template>
  <el-popconfirm
    v-bind="$attrs"
    :cancel-button-text="t('popconfirm.no')"
    :confirm-button-text="t('popconfirm.yes')"
  >
    <template
      v-for="(_, scopedSlotName) in $slots"
      #[scopedSlotName]="slotData"
    >
      <slot :name="scopedSlotName" v-bind="slotData" />
    </template>

    <template v-for="(_, slotName) in $slots" #[slotName]>
      <slot :name="slotName" />
    </template>
  </el-popconfirm>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>
